function initEngraving(root = document) {
  root.querySelectorAll('[data-engraving-section]').forEach((engravingSection) => {
    if (engravingSection.dataset.initialized === 'true') return;

    const engravingInput = engravingSection.querySelector('[data-engraving-input]');
    const engravingRemaining = engravingSection.querySelector('[data-engraving-remaining]');
    const engravingPrice = engravingSection.querySelector('[data-engraving-price]');
    const engravingValue = engravingSection.querySelector('[data-engraving-value]');
    const fontOptions = engravingSection.querySelectorAll('[data-font-option]');
    const fontOptionsContainer = engravingSection.querySelector('[data-engraving-font-options]');
    const engravingPreview = engravingSection.querySelector('[data-engraving-preview]');
    const engravingPreviewText = engravingSection.querySelector('[data-engraving-preview-text]');
    const engravingTextProperty = engravingSection.querySelector('[data-engraving-text-property]');
    const engravingFontProperty = engravingSection.querySelector('[data-engraving-font-property]');
    const engravingSupplement = engravingSection.querySelector('[data-engraving-supplement]');
    const productContainer = engravingSection.closest('.product__info-container');
    const addToCartButton = productContainer?.querySelector('.product-form__submit[name="add"]');
    const engravingVariantId = Number(engravingSection.dataset.engravingVariantId);
    const engravingPriceInCents = Number(engravingSection.dataset.engravingVariantPrice);

    if (
      !engravingInput ||
      !engravingRemaining ||
      !engravingPrice ||
      !engravingValue ||
      !fontOptions.length ||
      !fontOptionsContainer ||
      !engravingPreview ||
      !engravingPreviewText ||
      !engravingTextProperty ||
      !engravingFontProperty ||
      !engravingSupplement ||
      !engravingVariantId ||
      !Number.isFinite(engravingPriceInCents)
    ) return;

    engravingSection.dataset.initialized = 'true';

    const getSelectedFont = () => {
      return engravingSection.querySelector('[data-font-option] input:checked')?.value || 'Minion';
    };

    const resetFontSelection = () => {
      fontOptions.forEach((option) => {
        const radio = option.querySelector('input[type="radio"]');
        radio.checked = radio.value === 'Minion';
      });
      engravingFontProperty.value = '';
    };

    const updatePreview = (text) => {
      engravingPreview.dataset.font = getSelectedFont();
      engravingPreviewText.textContent = text;
    };

    const updateSummary = () => {
      const text = engravingInput.value.trim();
      const formattedPrice = engravingPriceInCents == null ? '' : formatMoney(engravingPriceInCents);
      const remainingCharacters = Math.max(0, engravingInput.maxLength - engravingInput.value.length);

      engravingRemaining.textContent = remainingCharacters;
      engravingValue.textContent = text || 'Non';
      engravingPrice.textContent = text && formattedPrice ? `(+${formattedPrice})` : '';
      engravingPrice.hidden = !text || !formattedPrice;
      engravingTextProperty.value = text;

      if (text) {
        fontOptionsContainer.disabled = false;
        fontOptionsContainer.classList.remove('disabled');
        engravingFontProperty.value = getSelectedFont();
        engravingSupplement.value = formattedPrice ? `Gravure: +${formattedPrice}` : '';
      } else {
        fontOptionsContainer.disabled = true;
        fontOptionsContainer.classList.add('disabled');
        engravingSupplement.value = '';
        resetFontSelection();
      }

      updatePreview(text);
    };

    engravingInput.addEventListener('input', updateSummary);

    fontOptions.forEach((option) => {
      const radio = option.querySelector('input[type="radio"]');
      radio.addEventListener('change', () => {
        const text = engravingInput.value.trim();
        engravingFontProperty.value = text ? getSelectedFont() : '';
        updatePreview(text);
      });
    });

    if (addToCartButton) {
      addToCartButton.addEventListener('click', async (event) => {
        const text = engravingInput.value.trim();
        if (!text) return;

        event.preventDefault();

        const font = engravingFontProperty.value;
        if (!font) {
          window.alert('Veuillez sélectionner une police pour la gravure.');
          engravingSection.querySelector('.engraving-dropdown').open = true;
          fontOptions[0]?.querySelector('input')?.focus();
          return;
        }

        const productForm = addToCartButton.closest('form[action*="/cart/add"]');
        if (!productForm) return;

        const formData = new FormData(productForm);
        const mainVariantId = formData.get('id');
        const quantity = Number(formData.get('quantity') || 1);
        if (!mainVariantId) return;

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const loadingSpinner = productForm.querySelector('.loading-overlay__spinner');

        addToCartButton.setAttribute('aria-disabled', 'true');
        addToCartButton.disabled = true;
        addToCartButton.classList.add('loading');
        loadingSpinner?.classList.remove('hidden');

        if (cart) cart.setActiveElement(addToCartButton);

        const requestBody = {
          items: [
            {
              id: Number(mainVariantId),
              quantity,
              properties: {
                'Gravure': 'Oui'
              }
            },
            {
              id: engravingVariantId,
              quantity: 1,
              parent_id: Number(mainVariantId),
              properties: { 
                '_engraving_addon': 'true',
                'Texte': text,
                'Police gravure': font
              }
            }
          ]
        };

        if (cart) {
          requestBody.sections = cart.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestBody)
          });

          const responseData = await response.json();
          if (!response.ok || responseData.status) {
            throw new Error(responseData.description || responseData.message || 'Unable to add engraving to cart');
          }

          if (!cart) {
            window.location.href = `${window.Shopify.routes.root}cart`;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainVariantId
            });
          }

          cart.renderContents(responseData);
        } catch (error) {
          console.error(error);
          window.alert(error.message || 'Une erreur est survenue lors de l’ajout de la gravure au panier.');
        } finally {
          addToCartButton.classList.remove('loading');
          addToCartButton.removeAttribute('aria-disabled');
          addToCartButton.disabled = false;
          loadingSpinner?.classList.add('hidden');
          if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
        }
      });
    }

    updateSummary();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initEngraving());
} else {
  initEngraving();
}

document.addEventListener('shopify:section:load', (event) => initEngraving(event.target));
